import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=0e0e0762&scoped=true"
import script from "./privacy.ts?vue&type=script&lang=ts&external"
export * from "./privacy.ts?vue&type=script&lang=ts&external"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=0e0e0762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0e0762",
  null
  
)

export default component.exports